/**
 * @enum {Number}
 */
export const REGION_ALI_LANG = {
  'zh-cn': 'cn',
  'en-us': 'en',
  'de' : 'de',
}

/**
 * @enum {Number}
 */
export const REGION_ALI_TELE = {
  'cn': '86',
  'eu': 'en',
  'sgp' : '0065',
}